module.exports = __webpack_public_path__ + "static/media/8-4.ff384b25.mp3";